export default __webpack_public_path__ + "static/media/codeBg.47780a3f.png";